if (!customElements.get('media-gallery')) {
  customElements.define(
    'media-gallery',
    class MediaGallery extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          liveRegion: this.querySelector('[id^="GalleryStatus"]'),
          viewer: this.querySelector('[id^="GalleryViewer"]'),
          thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
        };
        this.mql = window.matchMedia('(min-width: 750px)');
        if (!this.elements.viewer || !this.elements.thumbnails) return;

        this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));
        const initialSlides = Array.from(this.elements.viewer.querySelectorAll('[data-media-id]'));
        this.loadDeferredImagesInSlides([initialSlides[1] || null].filter(Boolean));
        this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
          mediaToSwitch
            .querySelector('button')
            .addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target, false));
        });
        if (this.dataset.desktopLayout.includes('thumbnail') && this.mql.matches) this.removeListSemantic();
      }

      onSlideChanged(event) {
        const currentSlideFromEvent = event?.detail?.currentElement;
        const currentSlide =
          currentSlideFromEvent ||
          this.elements.viewer.querySelector('.product__media-item.is-active') ||
          this.elements.viewer.querySelector('[data-media-id]');
        const currentThumbnail = this.elements.thumbnails
          .querySelector('button[aria-current="true"]')
          ?.closest('[data-target]');
        const mediaId = currentSlide?.dataset?.mediaId || currentThumbnail?.dataset?.target;
        if (!mediaId) return;

        const thumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
        if (!thumbnail) return;
        this.setActiveThumbnail(thumbnail);

        const currentSlideEl =
          currentSlideFromEvent || this.elements.viewer.querySelector('.product__media-item.is-active');
        if (currentSlideEl) {
          const allSlides = Array.from(this.elements.viewer.querySelectorAll('[data-media-id]'));
          const idx = allSlides.indexOf(currentSlideEl);
          this.loadDeferredImagesInSlides([allSlides[idx], allSlides[idx + 1] || null].filter(Boolean));
        }
      }

      setActiveMedia(mediaId, prepend) {
        const activeMedia =
          this.elements.viewer.querySelector(`[data-media-id="${mediaId}"]`) ||
          this.elements.viewer.querySelector('[data-media-id]');
        if (!activeMedia) {
          return;
        }

        const viewer = this.elements.viewer;
        const viewerSlider = viewer?.slider || activeMedia.parentElement;

        this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
          element.classList.remove('is-active');
        });
        activeMedia?.classList?.add('is-active');

        if (prepend) {
          activeMedia.parentElement.firstChild !== activeMedia && activeMedia.parentElement.prepend(activeMedia);

          if (this.elements.thumbnails) {
            const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
            activeThumbnail.parentElement.firstChild !== activeThumbnail && activeThumbnail.parentElement.prepend(activeThumbnail);
          }

          if (viewer?.slider) viewer.resetPages();
        }

        this.preventStickyHeader();
        window.setTimeout(() => {
          if (viewerSlider) {
            if (typeof viewer?.setSlidePosition === 'function') {
              viewer.setSlidePosition(activeMedia.offsetLeft);
            } else {
              viewerSlider.scrollTo({ left: activeMedia.offsetLeft });
            }
          }

          if (!this.mql.matches) return;

          const activeMediaRect = activeMedia.getBoundingClientRect();
          // Don't scroll if the image is already in view
          if (activeMediaRect.top > -0.5) return;
          const top = activeMediaRect.top + window.scrollY;
          window.scrollTo({ top: top, behavior: 'smooth' });
        });
        this.playActiveMedia(activeMedia);

        if (!this.elements.thumbnails) return;
        const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
        this.setActiveThumbnail(activeThumbnail);
        this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);

        const allSlides = Array.from(this.elements.viewer.querySelectorAll('[data-media-id]'));
        const activeIndex = allSlides.indexOf(activeMedia);
        this.loadDeferredImagesInSlides([allSlides[activeIndex], allSlides[activeIndex + 1] || null].filter(Boolean));
      }

      setActiveThumbnail(thumbnail) {
        if (!this.elements.thumbnails || !thumbnail) return;

        this.elements.thumbnails
          .querySelectorAll('button')
          .forEach((element) => element.removeAttribute('aria-current'));
        thumbnail.querySelector('button').setAttribute('aria-current', true);
        if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;

        this.elements.thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft });
      }

      announceLiveRegion(activeItem, position) {
        const image = activeItem.querySelector('.product__modal-opener--image img');
        if (!image) return;
        image.onload = () => {
          this.elements.liveRegion.setAttribute('aria-hidden', false);
          this.elements.liveRegion.textContent = window.accessibilityStrings.imageAvailable.replace('[index]', position);
          setTimeout(() => {
            this.elements.liveRegion.setAttribute('aria-hidden', true);
          }, 2000);
        };
        image.src = image.src;
      }

      playActiveMedia(activeItem) {
        window.pauseAllMedia();
        const deferredMedia = activeItem.querySelector('.deferred-media');
        if (deferredMedia) deferredMedia.loadContent(false);
      }

      loadDeferredImagesInSlides(slides) {
        slides.forEach((slide) => {
          if (!slide) return;
          const img = slide.querySelector('img[data-srcset]');
          if (!img || img.dataset.deferred === 'loaded') return;
          if (img.dataset.srcset) img.srcset = img.dataset.srcset;
          if (img.dataset.sizes) img.sizes = img.dataset.sizes;
          if (img.dataset.src) img.src = img.dataset.src;
          img.dataset.deferred = 'loaded';
        });
      }

      preventStickyHeader() {
        this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
        if (!this.stickyHeader) return;
        this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
      }

      removeListSemantic() {
        if (!this.elements.viewer.slider) return;
        this.elements.viewer.slider.setAttribute('role', 'presentation');
        this.elements.viewer.sliderItems.forEach((slide) => slide.setAttribute('role', 'presentation'));
      }
    }
  );
}
